export const DATA = {
  MAX_SERVICES: 6,
  MAX_GAMES: 8
}



// WEBPACK FOOTER //
// ./src/constants/data.js